import {
  AnimationState,
  AnimationText,
} from "@/features/iris/contracts/iris.contracts";
import { ANIMATIONS } from "@/features/iris/static/iris.static";
import { useCallback, useMemo, useState } from "react";

type UseIrisProgressModal = {
  hideTimeout?: number;
  text?: AnimationText;
};

export const useIrisProgressModal = (options?: UseIrisProgressModal) => {
  const [open, setOpen] = useState(false);
  const [state, setState] = useState<AnimationState>("busy");

  const stateText = useMemo(() => {
    const text = options?.text;
    return text ? text[state].text : ANIMATIONS[state].text;
  }, [options?.text, state]);

  const show = useCallback(() => setOpen(true), []);

  const hide = useCallback(
    (state: "done" | "error") => {
      setState(state);

      if (state === "error") {
        return;
      }

      const timeout = options?.hideTimeout ?? 2000;

      const id = setTimeout(() => {
        setOpen(false);
        setState("busy");
      }, timeout);

      /** Unmounted - cleanup. */
      return () => {
        clearTimeout(id);
      };
    },
    [options?.hideTimeout]
  );

  const handleClose = useCallback(() => {
    if (state !== "error") {
      return;
    }

    setOpen(false);
    setState("busy");
  }, [state]);

  return { open, state, stateText, show, hide, handleClose };
};
